<template>
  <div class="goods-box van-hairline--bottom">
    <div class="image">
      <img :src="goods.ProductImage" v-lazy="goods.ProductImage" alt />
    </div>
    <div class="info">
      <div class="info-item">
        <div class="info-item-left">
          <span class="p-title">{{goods.ProductTitle}}</span>
        </div>
        <div class="info-item-right">
          <span>￥{{goods.Price}}</span>
        </div>
      </div>
      <div class="info-item">
        <div class="info-item-left">
          <span class="sku-f">{{goods.StockTitle}}</span>
        </div>
        <div class="info-item-right">
          <span class="sku-f">x {{goods.Count}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkuItem",
  props: {
    goods: {}
  },
  data() {
    return {
      key: "value"
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
@import "../assets/base-var.less";
.goods-box {
  display: flex;
  background: #fff;
  padding: 5px 0;
  font-size: 14px;
}

.goods-box .image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
.goods-box .image img {
  max-width: 100%;
  border-radius: 4px;
}
.goods-box .info {
  flex: 1;
}
.info-item {
  display: flex;
  margin-bottom: 5px;
}
.info-item-right {
  width: 60px;
  text-align: right;
}
.info-item-left {
  flex: 1;
  text-align: left;
}
.p-title {
  font-weight: 500;
}
.p-price {
  color: #f44;
}
.sku-f {
  font-size: 12px;
  color: @gray-color;
}
</style>